
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";
import { TestResponse } from "@/types/test-response";
import { useRecruitmentStatus } from "@/hooks/useRecruitmentStatus";

interface RecruitmentNotesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  response: TestResponse;
}

export function RecruitmentNotesDialog({
  open,
  onOpenChange,
  response,
}: RecruitmentNotesDialogProps) {
  const [newNotes, setNewNotes] = useState(response.recruitment_notes || "");
  const { updateRecruitmentNotes, isUpdating } = useRecruitmentStatus();

  const handleSave = async () => {
    try {
      await updateRecruitmentNotes.mutateAsync({
        responseId: response.id,
        notes: newNotes,
      });
      onOpenChange(false);
    } catch (error) {
      // Error is already handled by the hook
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] bg-card text-card-foreground">
        <DialogHeader>
          <DialogTitle className="text-card-foreground">Recruitment Notes</DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Add notes about candidate: {response.candidate.full_name}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Textarea
            value={newNotes}
            onChange={(e) => setNewNotes(e.target.value)}
            placeholder="Add notes about the candidate's performance, interview feedback, or next steps..."
            className="min-h-[150px] 
              bg-card 
              text-card-foreground 
              border-input 
              placeholder:text-muted-foreground 
              focus-visible:ring-ring"
          />
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            className="bg-card text-card-foreground border-border hover:bg-accent"
            disabled={isUpdating}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSave}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
            disabled={isUpdating}
          >
            Save Notes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
